import apiClient from './apiClient';

/**
 * @author pjh
 * @date 2025.07.31
 * @description 복비 관련 API 서비스
 */

// 복비 입금 요청 타입
export interface IBokbiDepositRequest {
  franchiseChargeHstId?: string;
  depositName: string;
  depositBank: string;
  depositAmount: number;
  description?: string;
  companyName: string;
  companyNumber: string;
  address: string;
  ceo: string;
  email: string;
}

// 복비 입금 신청 API
export const createBokbiDeposit = async (data: IBokbiDepositRequest): Promise<void> => {
  await apiClient.post('/purchase-order', data);
};

// 복비 주문서 조회 타입
export interface IBokbiPurchaseOrder {
  depositName: string;
  depositBank: string;
  depositAmount: number;
  description: string;
  createdAt: string;
  companyName: string;
  companyNumber: string;
  address: string;
  email: string;
  ceo: string;
  chargeType: string;
}

// 복비 주문서 조회 API
export const getBokbiPurchaseOrder = async (purchaseOrderId: string): Promise<IBokbiPurchaseOrder> => {
  const response = await apiClient.get<IBokbiPurchaseOrder>(`/purchase-order/${purchaseOrderId}`);
  return response.data;
};

export const agreePurchaseOrder = async (franchiseChargeHstId: string, type: string, memo?: string): Promise<void> => {
  const params = memo ? { memo } : undefined;
  await apiClient.post(`/charge-hst/agree/${franchiseChargeHstId}/${type}`, null, { params });
};
